export const TypeFile = {
  XLSX: 0,
  PDF: 1,

  values () {
    return [
      this.XLSX,
      this.PDF,
    ]
  },

  getDescription (status) {
    switch (status) {
      case this.XLSX:
        return 'xlsx'
      case this.PDF:
        return 'pdf'
      default:
        return ''
    }
  },

  getTypes (status) {
    switch (status) {
      case this.XLSX:
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      case this.PDF:
        return 'application/pdf'
      default:
        return ''
    }
  },
}
